import { render, staticRenderFns } from "./FeatureCardData.vue?vue&type=template&id=2cf15fba&scoped=true&"
import script from "./FeatureCardData.vue?vue&type=script&lang=js&"
export * from "./FeatureCardData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf15fba",
  null
  
)

export default component.exports